module.exports = __webpack_public_path__ + "static/media/apartment6.b620bd32.jpg";